module.exports = __webpack_public_path__ + "static/media/doc.c72dfa70.svg";